import DeploymentActionResource from "client/resources/deploymentActionResource";
import {client} from "clientInstance";

export default function getActionLogoUrl(action: DeploymentActionResource) {
    const templateId = action.Properties["Octopus.Action.Template.Id"];
    const version = action.Properties["Octopus.Action.Template.Version"];
    return templateId ?
        client.resolveLinkTemplate("ActionTemplateVersionedLogo", {typeOrId: templateId, version}) :
        client.resolveLinkTemplate("ActionTemplateLogo", {typeOrId: action.ActionType});
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/projects/components/getActionLogoUrl.ts